"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardshipReliefOfferExpirationErrorCode = exports.HardshipReliefOfferCancelErrorCode = exports.HardshipReliefOfferExecutionErrorCode = exports.HardshipReliefOfferCreateErrorCode = exports.HardshipReliefOfferGetErrorCode = exports.HardshipReliefOfferGenericErrorCode = exports.HardshipReliefExecutionStatus = exports.ACTIVE_HARDSHIP_RELIEF_STATUSES = exports.HardshipReliefStatus = exports.HardshipReliefExecutionType = exports.HardshipReliefType = void 0;
var HardshipReliefType;
(function (HardshipReliefType) {
    /* The sip will extend past maturity, but the account will still be forced to payoff on maturity via balloon payment */
    HardshipReliefType["maybeExtendMaturitySweepAccountToSipAndRevokeLine"] = "maybeExtendMaturitySweepAccountToSipAndRevokeLine";
    HardshipReliefType["sweepAccountToMaturitySip"] = "sweepAccountToMaturitySip";
    HardshipReliefType["reamortizeAllSips"] = "reamortizeAllSips";
})(HardshipReliefType || (exports.HardshipReliefType = HardshipReliefType = {}));
var HardshipReliefExecutionType;
(function (HardshipReliefExecutionType) {
    HardshipReliefExecutionType["extendAccountMaturity"] = "extendAccountMaturity";
    HardshipReliefExecutionType["sweepPortfolioToSip"] = "sweepPortfolioToSip";
    HardshipReliefExecutionType["revokeLine"] = "revokeLine";
    HardshipReliefExecutionType["reamortizeSip"] = "reamortizeSip";
})(HardshipReliefExecutionType || (exports.HardshipReliefExecutionType = HardshipReliefExecutionType = {}));
/** @TranslateToPython */
var HardshipReliefStatus;
(function (HardshipReliefStatus) {
    HardshipReliefStatus["pending"] = "pending";
    HardshipReliefStatus["sentToCustomer"] = "sentToCustomer";
    HardshipReliefStatus["accepted"] = "accepted";
    HardshipReliefStatus["executed"] = "executed";
    HardshipReliefStatus["canceled"] = "canceled";
    HardshipReliefStatus["expired"] = "expired";
})(HardshipReliefStatus || (exports.HardshipReliefStatus = HardshipReliefStatus = {}));
exports.ACTIVE_HARDSHIP_RELIEF_STATUSES = [HardshipReliefStatus.pending, HardshipReliefStatus.sentToCustomer, HardshipReliefStatus.accepted];
var HardshipReliefExecutionStatus;
(function (HardshipReliefExecutionStatus) {
    HardshipReliefExecutionStatus["pending"] = "pending";
    HardshipReliefExecutionStatus["executed"] = "executed";
    HardshipReliefExecutionStatus["canceled"] = "canceled";
})(HardshipReliefExecutionStatus || (exports.HardshipReliefExecutionStatus = HardshipReliefExecutionStatus = {}));
var HardshipReliefOfferGenericErrorCode;
(function (HardshipReliefOfferGenericErrorCode) {
    HardshipReliefOfferGenericErrorCode["EXPIRED_OFFER"] = "EXPIRED_OFFER";
    HardshipReliefOfferGenericErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    HardshipReliefOfferGenericErrorCode["INVALID_STATUS"] = "INVALID_STATUS";
})(HardshipReliefOfferGenericErrorCode || (exports.HardshipReliefOfferGenericErrorCode = HardshipReliefOfferGenericErrorCode = {}));
var HardshipReliefOfferGetErrorCode;
(function (HardshipReliefOfferGetErrorCode) {
    HardshipReliefOfferGetErrorCode["NO_OFFER_FOUND"] = "NO_OFFER_FOUND";
})(HardshipReliefOfferGetErrorCode || (exports.HardshipReliefOfferGetErrorCode = HardshipReliefOfferGetErrorCode = {}));
var HardshipReliefOfferCreateErrorCode;
(function (HardshipReliefOfferCreateErrorCode) {
    HardshipReliefOfferCreateErrorCode["INVALID_EXPIRATION_DATE"] = "INVALID_EXPIRATION_DATE";
    HardshipReliefOfferCreateErrorCode["CORE_CARD_EOD_HOLD"] = "CORE_CARD_EOD_HOLD";
    HardshipReliefOfferCreateErrorCode["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
})(HardshipReliefOfferCreateErrorCode || (exports.HardshipReliefOfferCreateErrorCode = HardshipReliefOfferCreateErrorCode = {}));
var HardshipReliefOfferExecutionErrorCode;
(function (HardshipReliefOfferExecutionErrorCode) {
    HardshipReliefOfferExecutionErrorCode["FAILED_TO_EXECUTE_HARDSHIP_RELIEF_EXECUTIONS"] = "FAILED_TO_EXECUTE_HARDSHIP_RELIEF_EXECUTIONS";
})(HardshipReliefOfferExecutionErrorCode || (exports.HardshipReliefOfferExecutionErrorCode = HardshipReliefOfferExecutionErrorCode = {}));
var HardshipReliefOfferCancelErrorCode;
(function (HardshipReliefOfferCancelErrorCode) {
    HardshipReliefOfferCancelErrorCode["CANT_CANCEL_WITH_EXECUTED_HARDSHIP_RELIEF_EXECUTIONS"] = "CANT_CANCEL_WITH_EXECUTED_HARDSHIP_RELIEF_EXECUTIONS";
})(HardshipReliefOfferCancelErrorCode || (exports.HardshipReliefOfferCancelErrorCode = HardshipReliefOfferCancelErrorCode = {}));
var HardshipReliefOfferExpirationErrorCode;
(function (HardshipReliefOfferExpirationErrorCode) {
    HardshipReliefOfferExpirationErrorCode["CANT_EXPIRE_WITH_EXECUTED_HARDSHIP_RELIEF_EXECUTIONS"] = "CANT_EXPIRE_WITH_EXECUTED_HARDSHIP_RELIEF_EXECUTIONS";
})(HardshipReliefOfferExpirationErrorCode || (exports.HardshipReliefOfferExpirationErrorCode = HardshipReliefOfferExpirationErrorCode = {}));
